<template>
  <div>
    <page-nav-bar
      :is-sticky="true"
      :back-button="true"
      :has-actions="false">
      <template slot="breadcrumb">
        <h1 class="page-header-breadcrumb-item is-uppercase">
          <span class="">{{ total }} Origines</span>
        </h1>
      </template>
      <template slot="before-actions">
        <router-link
          v-if="isAdmin"
          class="page-header-btn is-small is-secondary is-widthFixToHeaderAccount"
          :to="{name: 'OriginCreate'}">
          <!--<span class="icon is-medium"><i class="fas fa-plus-circle"></i></span>-->
          <span>Créer origine</span>
        </router-link>
      </template>
    </page-nav-bar>
    <page-content
      :has-sticky-col-left="true"
      :has-left-col-collapse="true"
      :opened-col="openedCol"
      :has-padd-right-normal="true">
      <template slot="left-col-small">
        <col-collapse-filter
          :has-filter="hasFilter"
          :loading="loading"
          @opened="openedCol = !openedCol"
          @resetFilters="resetFilters()">
          <div class="is-padding">
            <div class="field">
              <div class="control">
                <input
                  id="name-origin-filter"
                  @input="updateSimpleFilter"
                  v-model="filters.name"
                  class="input"
                  type="text"
                  placeholder="Nom">
              </div>
            </div>
            <div class="control is-padding-bottom-xsmall">
              <div class="select is-fullwidth">
                <select
                  id="status-origin-filter"
                  @input="updateSimpleFilter"
                  v-model="filters.parent"
                  class="has-text-weight-medium">
                  <option :value="null">
                    Tous
                  </option>
                  <option value="isnull">
                    Origines
                  </option>
                  <option value="notnull">
                    Sous-origines
                  </option>
                </select>
              </div>
            </div>
            <div class="control">
              <div class="select is-fullwidth">
                <select
                  id="archived-origin-filter"
                  @input="updateSimpleFilter"
                  v-model="filters.archived"
                  class="has-text-weight-medium">
                  <option :value="null">
                    Tous
                  </option>
                  <option :value="'1'">
                    Archivé
                  </option>
                  <option :value="'0'">
                    Active
                  </option>
                </select>
              </div>
            </div>
          </div>
        </col-collapse-filter>
      </template>
      <div class="is-border">
        <div class="row-width-actions-bar is-border-bottom">
          <div class="columns is-gapless">
            <transition
              enter-active-class="animated fadeIn fasterx2"
              leave-active-class="animated fadeOut fasterx2"
              mode="out-in">
              <div
                class="column is-narrow has-background-primary has-text-white is-flex"
                v-if="hasFilter">
                <div
                  class="is-self-centered is-padding-left is-padding-right"
                  :data-count="count">
                  Résultat : {{ count }} origine(s)
                </div>
              </div>
            </transition>
          </div>
        </div>
        <filters-tags
          id="origin-tag"
          :has-filter="hasFilter"
          :filters="filters"
          @reset="resetFilters"
          @update="updateFromTag($event)"></filters-tags>
        <spinner-round
          :is-loading="loading"
          v-if="loading"></spinner-round>

        <table-controls-vue
          v-if="!loading && items.length"
          :has-sticky="true"
          :no-scroll-direction="false">
          <table class="table is-narrow is-fullwidth is-last-fixed-small has-actionsontd">
            <thead class="has-cells-vcentered">
              <tr class="is-size-6">
                <th>
                  <sortable
                    sort-id="name"
                    @sort="sort('name', $event)"
                    :sort="sortBy.name"
                    label="Nom"></sortable>
                </th>
                <th class="is-narrow">
                  Archivé
                </th>
                <th
                  v-if="mgcEnabled"
                  class="is-narrow">
                  Multidiffusion
                </th>
                <th class="has-text-centered"></th>
              </tr>
            </thead>
            <tbody class="has-cells-vcentered">
              <tr
                v-for="(origin) in items"
                :key="origin.pk"
                class="is-size-6"
                :id="'e' + origin.pk"
                :class="{'has-status-bar--left has-status-bar--draft': lastOpenedItemPk === origin.pk}">
                <td class="is-cell-hoverable">
                  <router-link
                    v-if="origin.parent"
                    :to="{name: 'OriginVue', params: {id: origin.parent.pk}}"
                    class="fullLink"
                    :title="origin.name">
                    {{ origin.name | truncate(120) }}
                  </router-link>
                  <router-link
                    v-else
                    :to="{name: 'OriginVue', params: {id: origin.pk}}"
                    class="fullLink"
                    :title="origin.name">
                    {{ origin.name | truncate(120) }}
                  </router-link>
                </td>
                <td>
                  <span v-if="origin.archived">Oui</span>
                  <span v-else>Non</span>
                </td>
                <td
                  v-if="mgcEnabled"
                  class="is-narrow">
                  <span v-if="origin.multidiffusion">Oui</span>
                  <span v-else>Non</span>
                </td>
                <td>
                  <display-button-list
                    :buttons="buttonList"
                    :data="origin">
                  </display-button-list>
                </td>
              </tr>
            </tbody>
          </table>
        </table-controls-vue>
        <div v-show="!loading && !items.length">
          <div class="is-padding">
            <h2 class="title is-3 has-text-weight-bold">
              Aucune origine disponible
            </h2>
          </div>
        </div>
        <pagination
          :loading="loading"
          :current-page="currentPage"
          :total-page="totalPage"
          @changePage="loadItems($event)"></pagination>
      </div>
    </page-content>
  </div>
</template>

<script>
import { concat, cloneDeep } from 'lodash'
import { GenericList, Sort, DefaultValues, Filter } from '@/mixins'
import moment from 'moment'
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'OriginList',
  mixins: [GenericList, Sort, DefaultValues, Filter],
  data () {
    return {
      originsFromGet: [],
      deleteTitle: 'Suppression origine',
      deleteText: 'Êtes vous sûr de vouloir supprimer cet élément ?',
      setQueryAtStart: true,
      filters: {
        name: null,
        archived: '0',
        parent: 'isnull'
      },
      initFilters: {
        name: null,
        archived: null,
        parent: null
      },
      buttonList: [
        {
          action: (id) => {
            this.$router.push({ name: 'OriginEdit', params: { id } })
          },
          needProfile: ['admin'],
          icon: 'fa-edit',
          text: 'Modifier origine'
        },
        {
          action: (id, data) => {
            if (data.protected) {
              this.$toasted.global.danger('Cette origine est liée à vos Multidiffusions et/ou Sites Publics, suppression impossible.')
            } else {
              if (!data.parent) {
                this.deleteText = 'La suppression de l\'origine entrainera la suppression des sous-origines qui lui sont liées. Si l\'une des sous-origines est  attribuée à un contact, l\'action de suppression échouera, il faudra archiver l\'origine ou modifier la sous-origine du contact en question.'
              } else {
                this.deleteTitle = 'Suppression sous-origine'
                this.deleteText = ' Les contacts ne pourront plus être attribués à cette sous-origine. Si la sous-origines est attribuée à un contact, l\'action de suppression échouera, il faudra archiver la sous-origine ou modifier la sous-origine du contact en question.'
              }
              this.deleteItemOrigin(id, data)
            }
          },
          needProfile: ['admin'],
          icon: 'fa-trash-alt',
          text: 'Supprimer'
        },
        {
          display: (o) => {
            return o.archived
          },
          action: (id, data) => {
            this.unArchive(data)
          },
          needProfile: ['admin'],
          icon: 'fa-archive',
          text: 'Désarchiver'
        },
        {
          display: (o) => {
            return !o.archived
          },
          action: (id, data) => {
            let title
            if (data.parent) {
              title = 'Archiver sous-origine'
            } else {
              title = 'Archiver origine'
            }
            this.confirmArchive(data, title)
          },
          needProfile: ['admin'],
          icon: 'fa-archive',
          text: 'Archiver'
        }
      ],
      loadDocuments: this.loadItems,
      service: 'ORIGIN',
      openedCol: false
    }
  },
  computed: {
    ...mapState(['lastOpenedItemPk', 'savedFilters']),
    ...mapGetters(['isAdmin', 'mgcEnabled']),
    today () {
      return moment()
    }
  },
  created () {
    if ('originList' in this.savedFilters) {
      this.loadOnCreate = false
      this.initSavedFilters()
    }
    // this.getOrigins()
  },
  methods: {
    initSavedFilters () {
      this.filters = cloneDeep(this.savedFilters.originList)
      this.updateSimpleFilter()
    },
    async deleteItemOrigin (pk, data) {
      let value = await this.confirmDelete()
      if (value.dismiss) return false // ON ne supprimme pas l'utilisateur
      if (value) {
        try {
          await this.$api.delete(this.$resources[this.service], pk)
          this.successDelete(pk)
        } catch (e) {
          console.log(e)
          this.afterErrorDelete(e.response.data.exception, data)
        }
      }
    },
    async getOrigins (page = 1) {
      let { data } = await this.$api.get(this.$resources.ORIGIN, { page })
      if (page > 1) {
        let totalOrigins = concat(data.items, this.originsFromGet)
        this.$store.commit('setOrigins', { origins: totalOrigins })
      } else {
        this.originsFromGet = data.items
        this.$store.commit('setOrigins', { origins: data.items })
      }
      if (data.page < data.pages) {
        page++
        this.getOrigins(page)
      }
    },
    afterSuccessDelete (pk) {
      this.$store.commit('removeOrigin', { originPk: pk })
    },
    afterErrorDelete (error, data) {
      let type
      if (data.parent) {
        type = 'sous-origine'
      } else {
        type = 'origine'
      }
      if (error === 'ORIGIN_USED_BY_CONTACTS') {
        this.confirmArchive(data, 'Un ou plusieurs contacts sont rattachés à cette ' + type + ', suppression impossible.')
      } else if (error === 'ORIGIN_USED_BY_RESERVATIONS') {
        this.confirmArchive(data, 'Une ou plusieurs réservations sont rattachées à cette ' + type + ', suppression impossible.')
      } else if (error === 'ORIGIN_USED_BY_PROGRAMS') {
        this.confirmArchive(data, 'Un ou plusieurs programmes sont rattachés à cette ' + type + ', suppression impossible.')
      } else if (error === 'ORIGIN_USED_BY_MGC_DIFFUSION') {
        this.confirmArchive(data, 'Une ou plusieurs multidiffusion sont rattachés à cette ' + type + ', suppression impossible.')
      } else {
        this.$toasted.global.danger('Erreur lors de la suppression de l\'origine')
      }
    },
    async confirmArchive (origin, title) {
      let text
      if (origin.parent) {
        text = 'Les contacts ne pourront plus être rattachés à cette sous-origine.'
      } else {
        text = 'Les contacts ne pourront plus être rattachés aux sous-origines qui sont liées à cette origine.'
      }
      let value = await this.$swal({
        title: title,
        text: text,
        confirmButtonText: 'Archiver',
        focusConfirm: false
      })
      if (value.dismiss) return false
      if (value) {
        this.archivedOrigin(origin)
      }
    },
    async archivedOrigin (origin) {
      let updatedOrigin = Object.assign({}, origin)
      updatedOrigin.archived = true
      if (updatedOrigin.parent) {
        updatedOrigin.parent = updatedOrigin.parent.pk
      }
      try {
        let { data } = await this.$api.put(this.$resources.ORIGIN, updatedOrigin.pk, updatedOrigin)
        this.$store.commit('updateOrigin', { origin: data })
        if ('children' in data && data.children) {
          for (let child of data.children) {
            this.$store.commit('updateOrigin', { origin: child })
          }
        }
        this.$toasted.global.success('Origine archivée')
        this.loadDocuments()
      } catch (err) {
        console.log(err)
      }
    },
    async unArchive (origin) {
      let updatedOrigin = Object.assign({}, origin)
      updatedOrigin.archived = false
      if (updatedOrigin.parent) {
        updatedOrigin.parent = updatedOrigin.parent.pk
      }
      try {
        let { data } = await this.$api.put(this.$resources.ORIGIN, updatedOrigin.pk, updatedOrigin)
        this.$store.commit('updateOrigin', { origin: data })
        this.loadDocuments()
        this.$toasted.global.success('Origine désarchivée')
      } catch (err) {
        console.log(err)
      }
    },
    beforeGet () {
      for (let key in this.filters) {
        this.$store.commit('setSavedFilters', { from: 'originList', name: key, value: this.filters[key] })
      }
    }
  }
}
</script>
